import { useAuth } from '../context/AuthContext';

export const useAuthContext = () => {
  return useAuth();
};

export default useAuthContext;
